import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { ProductosService } from '../../../services/productos.service';
import { HelpersService } from '../../../services/tools/helpers.service';

@Component({
  selector: 'app-formulario-producto',
  templateUrl: './formulario-producto.component.html',
  styleUrls: ['./formulario-producto.component.scss']
})
export class FormularioProductoComponent implements OnInit {
    @Output() productoGuardado: EventEmitter<any> = new EventEmitter;
    @Output() accionCancelada: EventEmitter<any> = new EventEmitter;
    @Input() id_producto: number = null;

    //Modelos
    public producto: any = { activo: true };
    public tiposServicios: any[] = [];

    //UI
    public permitirEditar: boolean = true;
    public errors: any = {}; 

    //helpers
    public tipoSeleccionado: any = {}; 
    public loadingTiposProductos: boolean = false;
    public loading: boolean = false;

    constructor(private productosService: ProductosService,
      private helperService: HelpersService) {
    }

    ngOnInit() {
      this.cargarTipoServicios();
    }

    ngOnChanges(changes: SimpleChanges) {
      //Si el cambio no fue del producto seleccionado, no requiere avanzar en la función
      if (!changes.id_producto) {
        return;
      }
      
      if(this.id_producto){
        this.obtenerProducto(this.id_producto);
      }else{
        this.producto = { activo: true };
        this.tipoSeleccionado = null;
      }
    }

    public guardar(){
      
      //Agregamos el productos seleccionado en el combo
      this.producto.id_tipo_servicio = this.tipoSeleccionado ? this.tipoSeleccionado.id_tipo_servicio : null;
      
      this.errors = this.productosService.validar(this.producto);
      if (Object.entries(this.errors).length > 0) {
        return false;
      }
      
      if(this.producto.id_producto){
        //Acturalizar un producto
        this.actualizarProducto(this.producto);
      }else{
        //Crear un nuevo producto
        this.crearProducto(this.producto);
      }
    }

    private crearProducto(producto){
      this.productosService.crear(producto).subscribe(
        (response)=>
        {
          const result = response.json().content;
          this.helperService.notification('Producto creado', 'Se ha registrado exitosamente el producto', 'success');

          this.productoGuardado.emit();
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          if(error.status == 400) {
            alert("ERROR: "+JSON.stringify(error));
          }
        }
      );
    }

    private actualizarProducto(producto){
      this.productosService.actualizar(producto).subscribe(
        (response)=>
        {
          const result = response.json().content;
          this.helperService.notification('Producto actualizado', 'Se ha actualizado exitosamente el producto', 'success');

          this.productoGuardado.emit();
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          if(error.status == 400) {
            alert("ERROR: "+JSON.stringify(error));
          }
        }
      );
    }

    public cargarTipoServicios(){
      this.loadingTiposProductos = true;
      this.productosService.listarTiposServicios()
      .subscribe(
          (response)=> {
              this.loadingTiposProductos = false;
              let content = response.json().content;
              this.tiposServicios = content;
          
          },
          (error) => {
          this.loadingTiposProductos = false;
          }
      );
    }

    public obtenerProducto(id_producto: number){
      this.loading = true;
      this.productosService.obtenerProducto(id_producto)
      .subscribe(
          (response)=> {
              this.loading = false;
              let producto = response.json().content;
              this.producto = producto;

              let component = this;
              this.tiposServicios.forEach(tipo => {
                if(tipo.id_tipo_servicio === producto.id_tipo_servicio){
                  component.tipoSeleccionado = tipo;
                }
              });
              
              this.actualizaDetallesImporte();
          },
          (error) => {
          this.loading = false;
          }
      );
    }

    public actualizaDetallesImporte(){
      let ivaCalculado = 0;
      let importeNeto = 0;
      
      if(this.producto.importe_bruto){
        ivaCalculado = (Number(this.producto.importe_bruto) * 0.16);
        //Redondeamos a 2 decimales el valor del iva
        importeNeto = (Number(this.producto.importe_bruto) + ivaCalculado);
      }

      this.producto.iva = ivaCalculado.toFixed(2);
      this.producto.importe_neto = importeNeto.toFixed(2);

    }

    public cancelarCaptura(){
      this.accionCancelada.emit();
    }

    public fotoSubida(event: any[]){
      //Se agregan al modelo las fotos que se han subido, para que se asocien al producto después de que se cree
      this.producto.fotos = event;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/catalogo-productos/formulario-producto/formulario-producto.component.ts